export enum ReeferEngineSpeedModeCategory {
    Unknown = -1,
    NormalSpeed = 0,
    HighSpeed = 1
}
